exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".month-arrow{width:14px;margin-bottom:3px}.month-arrow.-right{transform:rotate(180deg)}.calendar-header{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:10px 0 0}.header-left,.header-right{-ms-flex:1;flex:1}.header-center{-ms-flex:3;flex:3;text-align:center}.title{display:inline-block;margin:0 35px 15px;min-width:100px;font-weight:700;font-size:18px!important}.next-month,.prev-month{cursor:pointer}@media (max-width:768px){.title{margin:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f1ab8cc","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/vue-calendar/calendar-header.vue
// module id = 885
// module chunks = 0